import React from 'react';
import {
  Text,
  TextAppearance,
  TextAlignment,
  Download,
  LinkButton,
} from '@vw-marketing/us-components';
import { CarHeaderContainer, PrintWrapper } from './styled';

export interface CarHeaderProps {
  model: string;
  year: number;
  showPrint?: boolean;
}

const CarHeader = ({ model, year, showPrint }: CarHeaderProps): JSX.Element => (
  <CarHeaderContainer>
    <Text appearance={TextAppearance.headline300}>Results for your</Text>
    <Text
      appearance={TextAppearance.headline300}
      textAlign={TextAlignment.center}
      bold
    >
      {`${year} ${model}`}
    </Text>

    {showPrint && (
      <PrintWrapper>
        <Text appearance={TextAppearance.copy200} bold>
          <LinkButton
            onClick={() => {
              window.print();
            }}
            isInline
          >
            <Download variant={'small'} /> Print Results
          </LinkButton>
        </Text>
      </PrintWrapper>
    )}
  </CarHeaderContainer>
);

export default CarHeader;
